// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatHeader__container-baa025 {
  flex-shrink: 0;
  box-shadow: var(--box-shadow-4);
  background-color: var(--base-0);
  border-bottom: 1px solid var(--base-20);
  z-index: 1;
  position: relative;
  overflow: hidden;
  height: 73px;
  box-sizing: border-box;
  --animation-timeout: 150ms;
}

.ChatHeader__multi-enter-c77abf {
  position: absolute;
  top: -72px;
  left: 0;
  right: 0;
}

.ChatHeader__multi-enter-active-a296e1 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  transition: top var(--animation-timeout) linear;
}

.ChatHeader__multi-exit-e27904 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.ChatHeader__multi-exit-active-e476af {
  position: absolute;
  top: -72px;
  left: 0;
  right: 0;
  transition: top var(--animation-timeout) linear;
}

.ChatHeader__header-enter-b8349e {
  position: absolute;
  bottom: -72px;
  left: 0;
  right: 0;
}

.ChatHeader__header-enter-active-eb5e93 {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  transition: bottom var(--animation-timeout) linear;
}

.ChatHeader__header-exit-b15e13 {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.ChatHeader__header-exit-active-acf6e5 {
  position: absolute;
  bottom: -72px;
  left: 0;
  right: 0;
  transition: bottom var(--animation-timeout) linear;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/ChatHeader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,+BAAA;EACA,+BAAA;EACA,uCAAA;EACA,UAAA;EAEA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EAEA,0BAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;AADF;;AAIA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,+CAAA;AADF;;AAIA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,+CAAA;AADF;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kDAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AADF;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,kDAAA;AADF","sourcesContent":[".container {\n  flex-shrink: 0;\n  box-shadow: var(--box-shadow-4);\n  background-color: var(--base-0);\n  border-bottom: 1px solid var(--base-20);\n  z-index: 1;\n\n  position: relative;\n  overflow: hidden;\n  height: 73px;\n  box-sizing: border-box;\n\n  --animation-timeout: 150ms;\n}\n\n.multi-enter {\n  position: absolute;\n  top: -72px;\n  left: 0;\n  right: 0;\n}\n\n.multi-enter-active {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  transition: top var(--animation-timeout) linear;\n}\n\n.multi-exit {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.multi-exit-active {\n  position: absolute;\n  top: -72px;\n  left: 0;\n  right: 0;\n  transition: top var(--animation-timeout) linear;\n}\n\n.header-enter {\n  position: absolute;\n  bottom: -72px;\n  left: 0;\n  right: 0;\n}\n\n.header-enter-active {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  transition: bottom var(--animation-timeout) linear;\n}\n\n.header-exit {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.header-exit-active {\n  position: absolute;\n  bottom: -72px;\n  left: 0;\n  right: 0;\n  transition: bottom var(--animation-timeout) linear;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChatHeader__container-baa025`,
	"multi-enter": `ChatHeader__multi-enter-c77abf`,
	"multiEnter": `ChatHeader__multi-enter-c77abf`,
	"multi-enter-active": `ChatHeader__multi-enter-active-a296e1`,
	"multiEnterActive": `ChatHeader__multi-enter-active-a296e1`,
	"multi-exit": `ChatHeader__multi-exit-e27904`,
	"multiExit": `ChatHeader__multi-exit-e27904`,
	"multi-exit-active": `ChatHeader__multi-exit-active-e476af`,
	"multiExitActive": `ChatHeader__multi-exit-active-e476af`,
	"header-enter": `ChatHeader__header-enter-b8349e`,
	"headerEnter": `ChatHeader__header-enter-b8349e`,
	"header-enter-active": `ChatHeader__header-enter-active-eb5e93`,
	"headerEnterActive": `ChatHeader__header-enter-active-eb5e93`,
	"header-exit": `ChatHeader__header-exit-b15e13`,
	"headerExit": `ChatHeader__header-exit-b15e13`,
	"header-exit-active": `ChatHeader__header-exit-active-acf6e5`,
	"headerExitActive": `ChatHeader__header-exit-active-acf6e5`
};
module.exports = ___CSS_LOADER_EXPORT___;
